import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  border-left: 1px solid ${(p) => p.theme.palette.primary[100]};
  padding: ${(p) => p.theme.spacing(0, 2.5)};
`;
